import React, { memo, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { SearchIndicadores } from "../../components/organisms";
import { IndicadorTemplate } from "../../components/templates";
import {
  Box,
  Card,
  Stack,
  Typography,
  Icon,
  Tab,
  TabContext,
  TabList,
  TabPanel,
} from "investira.react.components";
import services from "../../services";
import withResponseHandling from "../../hoc/withResponseHandling";

const Indices = memo(() => {
  const [indicadorTipo, setIndicadorTipo] = useState("C");
  const [indicadores, setIndicadores] = useState([]);

  const INDICADORES_TIPO = useRef({
    M: {
      label: "Moeda",
      id: "M",
      icon: "coin",
    },
    C: {
      label: "Correção Monetária",
      id: "C",
      icon: "coins",
    },
    I: {
      label: "Índice de Mercado",
      id: "I",
      icon: "chart_line",
    },
    J: {
      label: "Juros",
      id: "J",
      icon: "percent",
    },
  });

  const handleChange = (_, pNewValue) => {
    setIndicadorTipo(pNewValue);
  };

  function renderList(pIndicadorTipo) {
    return (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "repeat(1, 1fr)",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(4, 1fr)",
          },
          gap: "12px 12px",
        }}
      >
        {indicadores
          .filter((xItem) => {
            return xItem.indicador_tipo_id == pIndicadorTipo;
          })
          .map((xIndicador, xIndex) => {
            const xKey = `indicador-${pIndicadorTipo}-${xIndex}`;
            const xIndicadoresTipo = INDICADORES_TIPO.current;

            return (
              <Card key={xKey}>
                <Link id={xKey} to={`/indicadores/${xIndicador.indicador_id}`}>
                  <Stack px={2} py={2} spacing={2}>
                    <Stack flexGrow={1}>
                      <Stack
                        backgroundColor="primary.main"
                        width="32px"
                        height="32px"
                        justifyContent="center"
                        alignItems="center"
                        borderRadius="8px"
                      >
                        <Icon
                          iconName={xIndicadoresTipo[pIndicadorTipo].icon}
                          color="secondary"
                          size={18}
                        />
                      </Stack>
                    </Stack>
                    <Stack flexGrow={1}>
                      <Typography
                        variant="body2"
                        gutterBottom
                        color="textPrimary"
                        sx={{ fontWeight: 600 }}
                      >
                        {xIndicador.indicador_id}
                      </Typography>
                      <Typography
                        variant="caption"
                        color="textPrimary"
                        sx={{ fontWeight: 400 }}
                      >
                        {xIndicador.indicador}
                      </Typography>
                    </Stack>
                  </Stack>
                </Link>
              </Card>
            );
          })}
      </Box>
    );
  }

  useEffect(() => {
    services.indicadores.list(
      {},
      (rRes) => {
        setIndicadores(rRes.data);
      },
      (rErr) => {
        console.log(rErr);
      }
    );
  }, []);

  return (
    <IndicadorTemplate
      title="Indicadores"
      description={`Indicadores econômicos como IPCA, IGPM, SELIC, CDI e outros índices importantes para o mercado financeiro`}
      searchComponent={<SearchIndicadores />}
      maxWidth="xl"
    >
      <TabContext value={indicadorTipo}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            id="tablist"
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab
              label={INDICADORES_TIPO.current.C.label}
              value={INDICADORES_TIPO.current.C.id}
            />
            <Tab
              label={INDICADORES_TIPO.current.J.label}
              value={INDICADORES_TIPO.current.J.id}
            />
            <Tab
              label={INDICADORES_TIPO.current.I.label}
              value={INDICADORES_TIPO.current.I.id}
            />
            <Tab
              label={INDICADORES_TIPO.current.M.label}
              value={INDICADORES_TIPO.current.M.id}
            />
          </TabList>
        </Box>

        <TabPanel
          id={`${INDICADORES_TIPO.current.C.id}-tabpanel`}
          value={INDICADORES_TIPO.current.C.id}
          sx={{
            px: 2,
          }}
        >
          {renderList(INDICADORES_TIPO.current.C.id)}
        </TabPanel>
        <TabPanel
          id={`${INDICADORES_TIPO.current.J.id}-tabpanel`}
          value={INDICADORES_TIPO.current.J.id}
          sx={{
            px: 2,
          }}
        >
          {renderList(INDICADORES_TIPO.current.J.id)}
        </TabPanel>
        <TabPanel
          id={`${INDICADORES_TIPO.current.I.id}-tabpanel`}
          value={INDICADORES_TIPO.current.I.id}
          sx={{
            px: 2,
          }}
        >
          {renderList(INDICADORES_TIPO.current.I.id)}
        </TabPanel>
        <TabPanel
          id={`${INDICADORES_TIPO.current.M.id}-tabpanel`}
          value={INDICADORES_TIPO.current.M.id}
          sx={{
            px: 2,
          }}
        >
          {renderList(INDICADORES_TIPO.current.M.id)}
        </TabPanel>
      </TabContext>
    </IndicadorTemplate>
  );
});

export default withResponseHandling(Indices);
